import { render, staticRenderFns } from "./SyncMenu.vue?vue&type=template&id=352ad9b8&"
import script from "./SyncMenu.vue?vue&type=script&lang=js&"
export * from "./SyncMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SyncMenu.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/menus/SyncMenu.vue
// module id = 2241
// module chunks = 1